"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _bookingDataActions = require("actions/bookingDataActions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  countryId: null
};

var extractCustomersFromLinkedBookings = function extractCustomersFromLinkedBookings(state) {
  return state.reduce(function (acc, current) {
    if (current.bookingCustomersData instanceof Array) {
      current.bookingCustomersData.forEach(function (customer) {
        acc[customer.id] = customer;
      });
    }
    return acc;
  }, {});
};

function booking() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _bookingDataActions.BOOKING_DATA_RECEIVED:
      if (action.bookingData) {
        return (0, _extends3.default)({}, state, action.bookingData);
      } else {
        return state;
      }

    case _bookingDataActions.LINKED_BOOKINGS_CUSTOMERS_DATA_RECEIVED:
      return (0, _extends3.default)({}, state, {
        linkedBookingsCustomers: extractCustomersFromLinkedBookings(action.linkedBookingsCustomersData)
      });

    case _bookingDataActions.COUNTRY_ID_SET:
      return (0, _extends3.default)({}, state, {
        countryId: action.countryId
      });

    default:
      return state;
  }
}

exports.default = booking;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./app/reducers/booking.js
// module id = 1392
// module chunks = 0